var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tips-container"},[_vm._m(0),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tips-header txt-sm"},[_c('span',{staticClass:"far fa-lightbulb"}),_vm._v(" Tips for Success ")])}]

export { render, staticRenderFns }